import React from 'react';
import { Positioning } from '../../../types/product';
import { ArrayInputField } from '../ArrayInputField';
import { TrustProofInput } from '../TrustProofInput';

interface PositioningSectionProps {
  value: Positioning;
  onChange: (value: Positioning) => void;
}

// 旧 styled 定義をそのまま Tailwind クラス文字列にした定数（sections 共通の見た目）。
const SECTION = 'bg-white border border-[#e0e0e0] rounded-lg p-6 mb-6';
const SECTION_TITLE = 'm-0 mb-2 text-[18px] font-semibold text-[#333]';
const SECTION_DESCRIPTION = 'm-0 mb-6 text-[14px] text-[#666]';

export const PositioningSection: React.FC<PositioningSectionProps> = ({
  value,
  onChange
}) => {
  const handlePopChange = (pop: string[]) => {
    onChange({ ...value, pop });
  };

  const handlePodChange = (pod: string[]) => {
    onChange({ ...value, pod });
  };

  const handleTrustProofChange = (trust_proof: typeof value.trust_proof) => {
    onChange({ ...value, trust_proof });
  };

  return (
    <div className={SECTION}>
      <h3 className={SECTION_TITLE}>ポジショニング</h3>
      <p className={SECTION_DESCRIPTION}>
        競合との差別化要因と信頼性の根拠を入力してください
      </p>

      <ArrayInputField
        label="Points of Parity (PoP) - 共通項目"
        value={value.pop || []}
        onChange={handlePopChange}
        placeholder="例: 定期配送／スキップ可"
        maxItems={10}
        helpText="競合と同等に提供する基本機能やサービス"
      />

      <ArrayInputField
        label="Points of Difference (PoD) - 差別化項目"
        value={value.pod || []}
        onChange={handlePodChange}
        placeholder="例: 停電時も常温供給可能"
        maxItems={10}
        helpText="競合との明確な差別化ポイント"
      />

      <TrustProofInput
        label="信頼の根拠"
        value={value.trust_proof || []}
        onChange={handleTrustProofChange}
        maxItems={10}
        helpText="第三者機関の認証、データ、実績など信頼性を裏付ける情報"
      />
    </div>
  );
};
